import React, { useState } from "react";
import { supabase } from "./supabaseClient";

const C = {
  navy: "#1F3A5F",
  red: "#C0392B",
  midBlue: "#2E75B6",
  light: "#BFD3F0",
  bg: "#EDF1F7",
  muted: "#6B7280",
  border: "#D6DEE8",
};

const FONT = "'Inter', system-ui, -apple-system, sans-serif";

export default function SetPassword({ onDone }) {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    if (pw.length < 8) { setError("Password must be at least 8 characters."); return; }
    if (pw !== pw2)    { setError("Passwords do not match."); return; }
    setBusy(true);
    const { error } = await supabase.auth.updateUser({ password: pw });
    setBusy(false);
    if (error) { setError(error.message); return; }
    onDone?.();
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: C.bg,
      fontFamily: FONT,
      display: "flex",
      flexDirection: "column",
    }}>
      <div style={{
        background: C.navy,
        color: "#fff",
        padding: "20px 32px",
        borderBottom: `4px solid ${C.red}`,
        display: "flex",
        alignItems: "center",
        gap: 20,
      }}>
        <img src="/esencee_logo.png" alt="Esencee Energy" style={{ height: 38, display: "block" }} />
        <div style={{ borderLeft: "1px solid rgba(255,255,255,0.2)", paddingLeft: 20 }}>
          <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: 0.3 }}>SolarSim Pro</div>
          <div style={{ fontSize: 12, color: C.light, marginTop: 2 }}>
            Engineering &amp; Business Development
          </div>
        </div>
      </div>

      <div style={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}>
        <form onSubmit={handleSubmit} style={{
          width: "100%",
          maxWidth: 380,
          background: "#fff",
          border: `1px solid ${C.border}`,
          borderRadius: 6,
          padding: 28,
        }}>
          <h1 style={{ margin: 0, marginBottom: 4, fontSize: 20, fontWeight: 700, color: C.navy }}>
            Set your password
          </h1>
          <p style={{ margin: 0, marginBottom: 20, fontSize: 12, color: C.muted }}>
            Choose a password to finish setting up your account.
          </p>

          <label style={lbl}>New password</label>
          <input type="password" required value={pw} onChange={e => setPw(e.target.value)}
            autoComplete="new-password" style={inp} />

          <label style={lbl}>Confirm password</label>
          <input type="password" required value={pw2} onChange={e => setPw2(e.target.value)}
            autoComplete="new-password" style={inp} />

          {error && (
            <div style={{
              marginTop: 12, padding: "8px 10px",
              background: "#FDECEC", border: `1px solid ${C.red}`,
              color: C.red, fontSize: 12, borderRadius: 4,
            }}>{error}</div>
          )}

          <button type="submit" disabled={busy} style={{
            width: "100%", marginTop: 20, padding: "10px 14px",
            background: C.navy, color: "#fff", border: "none", borderRadius: 4,
            fontSize: 14, fontWeight: 500, fontFamily: FONT,
            cursor: busy ? "default" : "pointer", opacity: busy ? 0.6 : 1,
          }}>
            {busy ? "Saving…" : "Set password and continue"}
          </button>
        </form>
      </div>
    </div>
  );
}

const lbl = {
  display: "block", fontSize: 11, fontWeight: 500, color: C.navy,
  marginTop: 12, marginBottom: 4, fontFamily: FONT,
};
const inp = {
  width: "100%", padding: "8px 10px",
  border: `1px solid ${C.border}`, borderRadius: 4,
  fontSize: 14, fontFamily: FONT, boxSizing: "border-box", outline: "none",
};
